/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmFunkcniMistoDenikSsl extends GContentBase<SeznamAdmFunkcniMistoDenikSslObj> {
        private seznamObj: SeznamAdmFunkcniMistoDenikSslObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmFunkcniMistoDenikSslObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmFunkcniMistoDenikSsl",
                contentCaption: "jres:33000622", //RC 33000622 : Funkční místa navázaná na deník
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{sslden} - {ixs_fun_txt}"
                },
                gridSettings: {
                    columnOrder: "sslden,ixs_fun_txt,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmFunkcniMistoDenikSslObj extends GAdmSeznamBase {
        sslden: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmFunkcniMistoDenikSsl", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmFunkcniMistoDenikSsl",
                newRecord: isNew,
                sslden: isNew == true ? ((this.sslden) ? this.sslden : null) : data.sslden,
                ixs_fun: isNew == true ? null : data.ixs_fun,
                subrada: isNew == true ? null : data.subrada
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:29808057").addField("gselectbox", Gordic.Prefabs.Select.sslsden(), {
                name: "sslden",
                model: "model.sslden=value.sslden",
                dropdown: true,
                disabled: (this.sslden) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.sslden) 
                hardFilter["sslden"] = this.sslden
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any, poradi_new?: number) {
            this.cnt.isl.AdmFunkcniMistoDenikSsl.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#{2}".format(data.ixs_fun, data.sslden, data.subrada),
                nazev: "{0} - {1}".format(data["ixs_fun"], data["sslden"])
            }
        }
    }
}